import { IBrandEmailSubscriptionStatus } from '@faire/web-api--source/com/faire/email/preferences/IBrandEmailSubscriptionStatus';

export namespace IUpdateRetailerBrandEmailPreferencesRequest {
  export enum BulkSubscribeStatus {
    BULK_SUBSCRIBE_STATUS_UNKNOWN = 'BULK_SUBSCRIBE_STATUS_UNKNOWN',
    NO_ACTION = 'NO_ACTION',
    UNSUBSCRIBE_TO_ALL = 'UNSUBSCRIBE_TO_ALL',
    RESUBSCRIBE_TO_ALL = 'RESUBSCRIBE_TO_ALL',
  }

  /**
   * Return an instance of IUpdateRetailerBrandEmailPreferencesRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IUpdateRetailerBrandEmailPreferencesRequest>
  ): IUpdateRetailerBrandEmailPreferencesRequest =>
    ({
      brand_email_preferences: [],
      ...(partial ?? {}),
    }) as IUpdateRetailerBrandEmailPreferencesRequest;
}

export interface IUpdateRetailerBrandEmailPreferencesRequest {
  brand_email_preferences: Array<IBrandEmailSubscriptionStatus>;
  bulk_action:
    | keyof typeof IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus
    | undefined;
  email_address: string | undefined;
}
